<template>
  <div class="form-body container-fluid">
    <div class="row">
      <div class="col">
        <alerter ref="alertbox" />
      </div>
    </div>
    <div class="row result-summary" v-if="completed">
      <div class="col">
        <h2>{{ $t('batchresult.summary') }}</h2>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th scope="col text-right">{{ $t('batchresult.amount') }}</th>
              <th scope="col">{{ $t('batchresult.result') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-right totalsuccess">{{ totalSuccess }}</td>
              <td>
                <span class="success">{{ columnTitleSuccess }}</span>
              </td>
            </tr>
            <tr>
              <td class="text-right totalignored">{{ totalIgnored }}</td>
              <td>
                <span class="ignored">{{ columnTitleIngored }}</span>
              </td>
            </tr>
            <tr>
              <td class="text-right">{{ totalFailed }}</td>
              <td>
                <span class="failed">{{ columnTitleFailed }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div v-show="!completed" class="progress">
          <div
            class="progress-bar"
            role="progressbar"
            aria-valuenow="70"
            aria-valuemin="0"
            aria-valuemax="100"
            :style="getPercentage()"
          >{{ percentage }}</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="scrollable-wrapper col">
        <ul class="batch-result-list p-4">
          <batch-result
            v-for="(item, index) in batchItemsVisible"
            v-bind:key="index"
            v-bind:description="item.description"
            v-bind:result="item.result"
            v-bind:error="item.error"
            :ref="'br-' + index"
          />
        </ul>
      </div>
    </div>

    <loading-spinner v-bind:loading="isBusy" />
  </div>
</template>
<script>
import Alerter from 'components/Alerter.vue';
import LoadingSpinner from 'components/LoadingSpinner.vue';
import BatchResult from 'components/BatchResult.vue';
import * as Enums from 'libs/enums.js';

export default {
  name: 'BatchResultView',
  components: {
    Alerter,
    'loading-spinner': LoadingSpinner,
    'batch-result': BatchResult
  },
  props: {
    /**
     * Viewmodels
     * @type {Array<{data: Object, result: String, description: String, error: String }>} 
     */
    batchItems: {
      default: () => []
    },
    /**
     * To override Success column
     * @type {String}
     */
    columnSuccess: {},
    /**
     * To override Ignored column
     * @type {String}
     */
    columnIngored: {},
    /**
     * To override Failed column
     * @type {String}
     */
    columnFailed: {},
    /**
     * To hide success rows
     * @type {String}
     */
    hideSuccess: {}
  },
  data: function() {
    return {
      isBusy: false,
      title: '',
      batchMethod: null,
    };
  },
  methods: {
    getPercentage() {
      let self = this;
      return {
        width: self.percentage + '%'
      };
    },
    updateScroll(item) {
      try {
        let self = this;
        let index = self.batchItems.indexOf(item);
        let reference = self.$refs['br-' + index][0];
        let element = reference.$el;
        element.scrollIntoView({ block: 'center' });
      } catch (err) {
        console.error(err);
      }
    }
  },
  computed: {
    completed() {
      let allcompleted = this.totalPending === 0;
      return allcompleted || false;
    },
    totalPending() {
      return this.batchItems.filter(x => x.result === Enums.ResultEnum.PENDING).length;
    },
    totalSuccess() {
      return this.batchItems.filter(x => x.result === Enums.ResultEnum.SUCCESS).length;
    },
    totalIgnored() {
      return this.batchItems.filter(x => x.result === Enums.ResultEnum.IGNORED).length;
    },
    totalFailed() {
      return this.batchItems.filter(x => x.result === Enums.ResultEnum.FAILED).length;
    },
    totalDone() {
      return this.batchItems.filter( x => x.result !== '' && x.result !== Enums.ResultEnum.PENDING).length;
    },
    percentage() {
      return Math.round((this.totalDone / this.batchItems.length) * 100);
    },
    columnTitleSuccess () {
      return this.columnSuccess || this.$t('batchresult.success');
    },
    columnTitleIngored () {
      return this.columnIngored || this.$t('batchresult.ignored');
    },
    columnTitleFailed () {
      return this.columnFailed || this.$t('batchresult.failed');
    },
    batchItemsVisible () {
      if (this.hideSuccess) {
        return this.batchItems.filter(x => x.result !== Enums.ResultEnum.SUCCESS);
      } else {
        return this.batchItems;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.batch-result-list {
  padding: 0px;
}
.result-summary {
  .success {
    font-weight: bold;
    color: green;
    background-color: transparent;
  }
  .ignored {
    font-weight: bold;
    color: black;
    background-color: transparent;
  }
  .failed {
    font-weight: bold;
    color: red;
    background-color: transparent;
  }
}
.scrollable-wrapper {
  overflow-y: scroll;
  overflow-x: hidden;
  max-height: 350px;
  padding: 0px;
}
</style>
